import React from 'react';
import {Link} from "react-router-dom";
import {ProductsMenu} from "./Products";
import {DownloadReportModal, Modal} from "react-spaceship-web";

export default class ProductsSerialNumber extends React.Component {
	constructor(props) {
		super(props);

		let _state = {
			count: 0,
		}
		_state.params = {};
		window.Route.on({
			'/v2/serial-number': (params) => {
				_state = {
					mode: 'list',
					params: params,
				};
			},
			'/v2/products/:product_id/serial-number': (params) => {
				_state = {
					mode: 'list',
					params: params,
				};
			},
			'/v2/products/:product_id/serial-number/:product_serial_number_id/edit': (params) => {
				_state = {
					mode: 'edit',
					params: params,
				};
			},
		}).match();
		_state.product = false;
		_state.product_serial_number = false;
		_state.products = [];
		_state.products_serial_number = [];
		_state.is_loading = true;
		_state.qs = window.Global.getAllQueryStrings();
		this.state = _state;
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			window.Route.on({
				'/v2/products/:product_id/serial-number': (params) => {
					this.setState({
						mode: 'list',
						is_loading: true,
						product: false,
						product_serial_number: false,
						params: params,
						products: [],
						product_price_condition: [],
						qs: window.Global.getAllQueryStrings(),
					}, () => {
						this.fetch();
					});
				},
				'/v2/products/:product_id/serial-number/:product_serial_number_id/edit': (params) => {
					this.setState({
						mode: 'edit',
						is_loading: true,
						product: false,
						product_serial_number: false,
						params: params,
						products: [],
						product_price_condition: [],
						qs: window.Global.getAllQueryStrings(),
					}, () => {
						this.edit();
					});
				},
				'/v2/serial-number': (params) => {
					this.setState({
						mode: 'list',
						is_loading: true,
						product: false,
						product_serial_number: false,
						products: [],
						products_serial_number: [],
						qs: window.Global.getAllQueryStrings(),
					}, () => {
						this.fetch();
					})
				},
			}).match();
		} else if (this.props.location.search !== prevProps.location.search) {
			// console.log(this.props);
			this.setState({
				mode: 'list',
				is_loading: true,
				product: false,
				product_serial_number: false,
				products: [],
				products_serial_number: [],
				qs: window.Global.getAllQueryStrings(),
			}, () => {
				this.fetch();
			})
		}
	}

	componentDidMount() {
		if (this.state.mode === 'list') {
			this.fetch();
		}
		if (this.state.mode === 'edit') {
			this.edit();
		}
	}

	scan() {
		window.$('.item-serial-number[data-scan_barcode="1"]').each((i, e) => {
			if (i !== 0) {
				return false
			}
			let data = window.$(e).data()

			window.$(e).find('.serial-number').html('<div class="ui active centered inline loader"/>')
			window.$(e).css({
				background: '#ffff0066',
			})
			window.$('#Root').scrollTo({
				scrollTo: window.$(e),
			})

			window.$(e).off('saveSerialNumber').on('saveSerialNumber', (e) => {
				// console.log(e.barcode)

				if (!e.barcode) {
					return
				}

				if (window.is_loading_scan_barcode_to_save_serial_number) {
					return
				}

				window.is_loading_scan_barcode_to_save_serial_number = true

				window.Global.ajax({
					method: 'POST',
					url: process.env.REACT_APP_DOMAIN + '/api/v1/product_serial_number/scan',
					data: {
						product_serial_number_id: data.product_serial_number_id,
						serial_number: e.barcode,
					},
					done: (response) => {
						window.is_loading_scan_barcode_to_save_serial_number = false

						if (response.error
							&& response.message
							&& response.message.length
						) {
							window.Global.messageTop({
								type: 'negative',
								message: response.message[0]['error_message']
							})
						}

						if (!response.success) {
							return
						}

						window.$(e).off('saveSerialNumber')

						let s = [...this.state.products_serial_number]
						s[data.index] = response.product_serial_number

						this.setState({
							products_serial_number: s,
						}, () => {
							this.scan()
						})
					}
				})
			})
		})
	}

	fetch() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/product_serial_number',
			data: {
				product_id: this.state.params.product_id,
				allow_deleted: 1,
				request_data_product: true,
				request_data_updated_user: true,

				all: this.state.qs.scan_barcode_to_save_serial_number
					? 'true'
					: '',

				request_data_cost_and_profit: true,

				...this.state.qs,
			},
			done: (response) => {
				let product = response.product || false;
				this.setState({
					product: product,
					stock: response.stock || false,
					purchase_order: response.purchase_order || false,
					supplier_relationship: response.supplier_relationship || false,
					customer_relationship: response.customer_relationship || false,
					products_serial_number: response.product_serial_number,
					is_loading: false,
					count: response.count,
					on_payment: response.on_payment || false,
				}, () => {
					let qs = window.Global.getAllQueryStrings()
					if (qs.scan_barcode_to_save_serial_number) {
						this.scan()

						window.$(document).on('onScanBarcode', (e) => {
							// console.log(e.barcode)

							window.$('.item-serial-number[data-scan_barcode="1"]').each((i, node) => {
								if (i !== 0) {
									return false
								}

								let event = window.$.Event("saveSerialNumber");
								event.barcode = e.barcode
								window.$(node).trigger(event);
							})
						})
					} else {
						window.$(document).on('onScanBarcode', (e) => {
							let qs = window.Global.getAllQueryStrings()
							if (qs.scan_barcode_to_save_serial_number) {
								return
							}

							window.$('#Search_root')
								.find('input[name="search_query"]')
								.val(e.barcode)

							setTimeout(() => {
								window.$('#Search_root form').trigger('submit')
							}, 500)
						})
					}

					if (!qs.scan_barcode_to_save_serial_number) {
						setTimeout(() => {
							this.$parent.find('.Table_root').tablePagination({
								disableContent: true,
								data: response.product_serial_number,
								count: response.count,
								onClickPagination: (p) => {
									let qs = window.Global.getAllQueryStrings();
									qs.page = p;
									this.props.history.push(window.Global.getQueryStringLinkFromObject(qs));
								}
							})
						}, 1000)
					}
				})
			},
			fail: () => {

			}
		})
	}

	edit() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/product_serial_number',
			data: {
				product_id: this.state.params.product_id,
				allow_deleted: 1,
				...this.state.qs,
			},
			done: (response) => {
				let product = response.product || false;
				window.Global.ajax({
					method: 'GET',
					url: process.env.REACT_APP_DOMAIN + '/api/product_serial_number',
					data: {
						product_id: this.state.params.product_id,
						product_serial_number_id: this.state.params.product_serial_number_id,
					},
					done: (response) => {
						this.setState({
							product: product,
							product_serial_number: response.product_serial_number[0],
							is_loading: false,
						})
					},
					fail: () => {

					}
				});
			},
			fail: () => {

			}
		});

	}

	renderHeader() {
		return (
			<div style={{marginBottom: '1rem'}}>
				<div className="flex row wrap middle-xs">
					<div className="ui huge breadcrumb">
						<Link className={"section active"}
						      to={"/v2/products"}>สินค้า</Link>
						{
							this.state.product
								?
								<>
									<span className="divider" style={{margin: '0px 1rem'}}>/</span>
									{
										this.state.mode === 'edit'
											?
											<Link to={"/v2/products/" + this.state.product.id + '/serial-number'}
											      className="section">
												{this.state.product.name} ({this.state.product.code})
											</Link>
											: null
									}
									{
										this.state.mode === 'list'
											?
											<div className="section">
												{this.state.product.name} ({this.state.product.code})
											</div>
											: null
									}
								</>
								: null
						}
						<span className="divider" style={{margin: '0px 1rem'}}>/</span>
						{
							this.state.mode === 'list'
								?
								<div className="section active">
									Serial number
								</div>
								: null
						}
						{
							this.state.mode === 'edit'
								?
								<div className={"section active"}>
									แก้ไข {this.state.product_serial_number.serial_number}
								</div>
								: null
						}
					</div>
				</div>
				<ProductsMenu product_id={this.state.product.id}
				              index={3}
				              search_serial_number={this.state.mode === "list"}
				              serial_number_input_value={this.state.qs.search_serial_number}
				              onSearchSubmit={(obj) => {
					              this.props.history.push({
						              pathname: '/v2/products/' + this.state.product.id + '/serial-number',
						              state: null,
						              search: "?search_serial_number=" + obj.search_serial_number + '&page=' + obj.page,
					              });
				              }}
				/>
			</div>
		);
	}

	downloadReport() {
		window.Global.reactToDom(
			window.$('body'),
			<div>
				<Modal className="ui modal tiny"
				       closable={false}
				       onShowToSetupForm={($modal) => {
					       // $modal.find('form').form2('setup');
					       $modal.find('form').form2('setup', {});
					       $modal.find('form').form2('submit', {
						       method: 'POST',
						       url: process.env.REACT_APP_DOMAIN + '',
						       beforeSent: (object) => {
							       $modal.modal('hide');

							       let data = this.$parent.find('form').serializeObject();
							       data.is_download_excel = true;

							       window.Global.reactToDom(
								       window.$('body'),
								       <DownloadReportModal
									       url={process.env.REACT_APP_DOMAIN + '/api/product'}
									       data={{
										       ...data,
										       ...object
									       }}
								       />
							       );

							       return false;
						       },
						       loadingButton: $modal.find('.button.approve'),
						       onSuccess: () => {

						       }
					       });
				       }}>
					<div className="header">
						<h2>ดาวโหลดรายการสินค้า</h2>
					</div>
					<div className="content">
						<form className="ui form">
							<div
								className="flex row wrap column one column computer padded">
								<div className="column field inline">
									<div className="ui checkbox">
										<input id="request_data_product_barcode"
										       type="checkbox"
										       tabIndex="0"
										       name="request_data_product_barcode"
										       className="hidden"
										       value="0"
										/>
										<label
											htmlFor="request_data_product_barcode">แสดง
											Barcode
											ทั้งหมดของสินค้า</label>
									</div>
								</div>
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div
									className="ui approve green right button">ดาวโหลด
								</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		)
	}

	scanToSaveSerialNumber() {
		window.Global.reactToDom(
			window.$('body'),
			<div>
				<Modal className="ui modal tiny"
				       closable={false}
				       onShowToSetupForm={($modal) => {
					       $modal.find('form').form2('setup', {})

					       $modal.find('input[name="purchase_order_id"]').explorer({
						       url: process.env.REACT_APP_DOMAIN + '/api/purchase_order',
						       additionalData: {
							       limit: 10,
							       page: 1,
						       },
						       key: 'purchase_order',
						       template: {
							       // list: '<a class="item flex row">{{code}} - {{date doc_date}}</a>',
							       list: (value) => {
								       // let search = $product.val();
								       return window.Handlebars.compile('<a class="item flex row"><b>{{code}}</b> - {{date doc_date}}</a>')(value)
							       },
							       selected: {
								       text: 'code',
								       value: 'id',
								       placeholder: ''
							       }
						       },
						       onSelected: () => {
							       setTimeout(() => {
								       $modal.find('form').trigger('submit')
							       }, 50)
						       }
					       })

					       setTimeout(() => {
						       $modal.find('input[name="search"]').focus()
					       }, 500)

					       $modal.find('form').form2('submit', {
						       method: 'POST',
						       url: process.env.REACT_APP_DOMAIN + '',
						       beforeSent: (object) => {
							       if (!object.purchase_order_id) {
								       return false
							       }

							       // let data = window.$('#Search_root form').serializeObject()

							       this.props.history.push(
								       window.Global.getQueryStringLinkFromObject({
									       // ...data,
									       // search_query: '',
									       // purchase_order_code: '',
									       status: 'available',
									       scan_barcode_to_save_serial_number: true,
									       status_serial_number_is_set: 'not_set',
									       purchase_order_id: object.purchase_order_id,
								       })
							       )

							       $modal.modal('hide')

							       return false;
						       },
						       loadingButton: $modal.find('.button.approve'),
						       onSuccess: () => {

						       }
					       })
				       }}>
					<div className="header">
						<h2>แสกนบันทึกซีเรียลนัมเบอร์ ด้วยการยิงบาร์โคด</h2>
					</div>
					<div className="content">
						<form className="ui form">
							<div className="flex row wrap column one column computer padded">
								<div className="column field">
									<label>เลือกใบสั่งซื้อ</label>
									<input type="text"
									       name="purchase_order_id"
									/>
								</div>
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div className="ui approve green right button">ตกลง</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		)
	}

	renderList() {
		// console.log(window.location);
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
			     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
			     className="main ui container"
			>
				{
					this.state.product
						?
						this.renderHeader()
						:
						(
							<div className={'mb-6'}>
								<div className="flex row wrap middle-xs">
									<div className="ui huge breadcrumb relative">
										<Link className={"section active"}
										      to={"/v2/serial-number"}>
											ซีเรียลนัมเบอร์
											<span data-tooltip={'Pro Version ทดลองใช้ฟรี'}
											      data-inverted={''}
											      data-position={'bottom center'}
											      className={'relative left-2 -top-4'}
											>
												<span className={'ui label green'}>Pro</span>
											</span>
										</Link>
									</div>
								</div>
							</div>
						)
				}
				<div className="">
					<div id="Search_root" className="box" style={{display: 'none', marginTop: '1rem'}}
					     ref={(ref) => {
						     let $search = window.$(ref);

						     window.Search.init({
							     $node: $search,
							     onSubmit: (data) => {
								     this.props.history.push(window.Global.getQueryStringLinkFromObject(data));
								     return false;
							     }
						     })

						     let $product = $search.find('input[name="product_id"]').explorer({
							     url: process.env.REACT_APP_DOMAIN + '/api/product',
							     additionalData: {
								     limit: 5,
								     page: 1,
								     is_serial_number: 1,
							     },
							     key: 'product',
							     template: {
								     list: (value) => {
									     let search = $product.val();
									     return window.GlobalTemplate.getProductSearchList(search, value);
								     },
								     selected: {
									     text: 'name',
									     value: 'id',
									     placeholder: 'เลือกสินค้า'
								     }
							     }
						     })
						     if (this.state.product) {
							     $product.explorer('set value', this.state.product)
						     }

						     let $stock = $search.find('input[name="stock_id"]').explorer({
							     url: process.env.REACT_APP_DOMAIN + '/api/stock',
							     additionalData: {
								     limit: 5,
								     page: 1
							     },
							     key: 'stock',
							     template: {
								     list: '<a class="item flex row">{{name}}</a>',
								     selected: {
									     text: 'name',
									     value: 'id',
									     placeholder: 'เลือกคลังสินค้า'
								     }
							     }
						     })
						     if (this.state.stock) {
							     $stock.explorer('set value', this.state.stock)
						     }

						     let $purchase_order = $search.find('input[name="purchase_order_id"]').explorer({
							     url: process.env.REACT_APP_DOMAIN + '/api/purchase_order',
							     additionalData: {
								     limit: 5,
								     page: 1,
							     },
							     key: 'purchase_order',
							     template: {
								     list: function (value) {
									     return window.Handlebars.compile('<a class="item flex row"><b>{{code}}</b><br>{{date doc_date}}</a>')(value);
								     },
								     selected: {
									     display_template: '<b>{{code}}</b> ({{date doc_date}})',
									     value: 'id',
									     placeholder: 'ค้นหาใบสั่งซื้อ'
								     }
							     }
						     })
						     if (this.state.purchase_order) {
							     $purchase_order.explorer('set value', this.state.purchase_order)
						     }

						     let $supplier_relationship = $search.find('input[name="supplier_relationship_id"]').explorer({
							     url: process.env.REACT_APP_DOMAIN + '/api/relationship',
							     additionalData: {
								     limit: 30,
								     page: 1,
								     is_supplier: 1,
							     },
							     key: 'relationship',
							     template: {
								     list: function (value) {
									     return window.Handlebars.compile('<a class="item flex row"><b>{{name}}</b><br>{{code}}</a>')(value);
								     },
								     selected: {
									     display_template: '<b>{{name}}</b> ({{code}})',
									     value: 'id',
									     placeholder: 'ค้นหาซัพพลายเออร์'
								     }
							     }
						     })
						     if (this.state.supplier_relationship) {
							     $supplier_relationship.explorer('set value', this.state.supplier_relationship)
						     }

						     let $customer_relationship = $search.find('input[name="customer_relationship_id"]').explorer({
							     url: process.env.REACT_APP_DOMAIN + '/api/relationship',
							     additionalData: {
								     limit: 30,
								     page: 1,
								     is_customer: 1,
							     },
							     key: 'relationship',
							     template: {
								     list: function (value) {
									     return window.Handlebars.compile('<a class="item flex row"><b>{{name}}</b><br>{{code}}</a>')(value);
								     },
								     selected: {
									     display_template: '<b>{{name}}</b> ({{code}})',
									     value: 'id',
									     placeholder: 'ค้นหาลูกค้า'
								     }
							     }
						     })
						     if (this.state.customer_relationship) {
							     $customer_relationship.explorer('set value', this.state.customer_relationship)
						     }

						     setTimeout(function () {
							     $search.find('.pointing.dropdown').dropdown({
								     onChange: function (value) {
									     let data = $search.find('form').serializeObject();
									     if (value === 'excel') {
										     data.is_download_excel = true;
										     window.Global.reactToDom(
											     window.$('body'),
											     <DownloadReportModal url={process.env.REACT_APP_DOMAIN + '/api/product'}
											                          data={data}
											     />
										     )
									     }
								     }
							     })
						     })
					     }}
					>
						<form className="ui form">
							<div className="flex row wrap padded five column computer">
								{
									this.state.qs.scan_barcode_to_save_serial_number
									&&
									<>
										<input type="hidden"
										       name={'scan_barcode_to_save_serial_number'}
										       defaultValue={this.state.qs.scan_barcode_to_save_serial_number}
										/>
										<input type="hidden"
										       name={'status_serial_number_is_set'}
										       defaultValue={this.state.qs.status_serial_number_is_set}
										/>
										<input type="hidden"
										       name={'back_url'}
										       defaultValue={this.state.qs.back_url || ""}
										/>
									</>
								}
								<div className={
									"column field"
								}>
									<label>สินค้า</label>
									<input name="product_id"/>
								</div>
								<div className="column field">
									<label>ค้นหา Serial Number</label>
									<input name="search_query"
									       data-form2_setup=""
									       placeholder={""}
									       readOnly={this.state.qs.scan_barcode_to_save_serial_number}
									/>
								</div>
								<div className="column field">
									<label>คลังสินค้า</label>
									<input type="hidden"
									       name="stock_id"
									       value=""
									/>
								</div>
								<div className="column field">
									<label>รหัสใบสั่งซื้อ</label>
									<input name="purchase_order_code"
									       data-form2_setup=""
									       placeholder={""}
									       readOnly={this.state.qs.scan_barcode_to_save_serial_number}
									/>
								</div>
								<div className="column field">
									<label>ใบสั่งซื้อ</label>
									<input name="purchase_order_id"/>
								</div>
								<div className="column field">
									<label>ซัพพลายเออร์</label>
									<input name="supplier_relationship_id"/>
								</div>
								<div className="column field">
									<label>ขายให้ลูกค้า</label>
									<input name="customer_relationship_id"/>
								</div>
								<div className="column field">
									<label>สถานะ</label>
									<div className="field">
										<select className="ui dropdown"
										        name="status"
										        data-form2_setup=""
										        disabled={this.state.qs.scan_barcode_to_save_serial_number}
										>
											<option value="all">ทั้งหมด</option>
											<option value="available">พร้อมใช้</option>
											<option value="sold">ขายแล้ว</option>
											<option value="void">ไม่พร้อมใช้ / ยกเลิก</option>
											<option value="purchase_order_return">คืนเจ้าหนี้</option>
											<option value="bom_adjustment_material">วัตถุดิบผลิตสินค้าใหม่</option>
										</select>
									</div>
								</div>
								<div className="column field">
									<label>อื่นๆ</label>
									<div className="field">
										<select className="ui dropdown"
										        name="status_serial_number_is_set"
										        data-form2_setup=""
										        disabled={this.state.qs.scan_barcode_to_save_serial_number}
										>
											<option value="all">ทั้งหมด</option>
											<option value="not_set">เฉพาะรายการที่ : ยังไม่ได้ระบุซีเรียลนัมเบอร์</option>
											<option value="set">เฉพาะรายการที่ : ระบุซีเรียลนัมเบอร์แล้ว</option>
										</select>
									</div>
								</div>
								<div className="column field">
									<label>เรียงข้อมูล</label>
									<div className="field">
										<select className="ui dropdown"
										        name="order_by"
										        data-form2_setup=""
										        disabled={this.state.qs.scan_barcode_to_save_serial_number}
										>
											<option value="newest">ใหม่สุด</option>
											<option value="oldest">เก่าสุด</option>
											<option value="name_asc">A-Z</option>
											<option value="name_desc">Z-A</option>
										</select>
									</div>
								</div>
								{
									!this.state.is_loading
									&&
									<div className="column field">
										<label>จำนวนทั้งหมด</label>
										<div className={'font-bold text-2xl'}>
											<span className={'text-green-700 pt-2'}>{this.state.count.format()}</span>
										</div>
									</div>
								}
								<div className="column field">
									<label>&nbsp;</label>
									<button className={"ui icon button"}
									        data-tooltip={'ค้นหาประวัติจากเอกสาร'}
									        data-inverted={''}
									        type="button"
									        onClick={() => {
										        window.Global.reactToDom(
											        window.$('body'),
											        <div>
												        <ProductSerialNumberFilterHistory
													        history={this.props.history}
													        qs={this.state.qs}
													        on_payment={this.state.on_payment || false}
												        />
											        </div>
										        )
									        }}
									>
										ค้นหาประวัติจากเอกสาร
										{
											(() => {
												let count = 0
												if (this.state.on_payment) {
													count++
												}
												if (this.state.qs.on_payment_start_doc_date
													|| this.state.qs.on_payment_end_doc_date
												) {
													count++
												}

												if (count === 0) {
													return null
												}

												return (
													<div className="floating ui red label circular">{count}</div>
												)
											})()
										}
									</button>
									<input type="hidden"
									       name={'on_payment_id'}
									       value={this.state.on_payment ? this.state.on_payment.id : ''}/>
									<input type="hidden"
									       name={'on_payment_start_doc_date'}
									       value={this.state.qs.on_payment_start_doc_date ? this.state.qs.on_payment_start_doc_date : ''}/>
									<input type="hidden"
									       name={'on_payment_end_doc_date'}
									       value={this.state.qs.on_payment_end_doc_date ? this.state.qs.on_payment_end_doc_date : ''}/>
								</div>
								<div className="column fluid right floated"
								     style={{marginBottom: '1rem'}}
								>
									<label style={{opacity: 0}}>&nbsp;</label>
									<div className="row wrap right floated end-xs flex gap-3">
										<button className="ui icon button"
										        data-tooltip={'นำเข้าข้อมูล'}
										        data-inverted={''}
										        type="button"
										        onClick={() => {
											        let data = window.$('#Search_root form').serializeObject()
											        data.is_download_excel = 1;
											        data.allow_deleted = 1;
											        // data.request_data_cost_and_profit = 1;

											        window.Global.reactToDom(
												        window.$('body'),
												        <DownloadReportModal
													        url={process.env.REACT_APP_DOMAIN + '/api/product_serial_number'}
													        data={data}
												        />
											        );
										        }}
										>
											ดาวโหลดรายงาน
										</button>
										{
											this.state.qs.scan_barcode_to_save_serial_number
												?
												<button className={"ui red button"}
												        type="button"
												        onClick={() => {
													        let url = ''
													        if (this.state.qs.back_url) {
														        window.location.href = decodeURIComponent(this.state.qs.back_url)
													        } else {
														        url = window.Global.getQueryStringLinkFromObject({
															        // ...data,
															        purchase_order_id: '',
															        purchase_order_code: this.state.purchase_order.code,
														        })
														        this.props.history.push(url)
													        }
												        }}
												>
													ยกเลิกแสกน
												</button>
												: null
										}
										<button className={
											this.state.qs.scan_barcode_to_save_serial_number
												? "ui icon green button"
												: "ui icon button"
										}
										        data-tooltip={'แสกนบันทึกซีเรียลนัมเบอร์ ด้วยการยิงบาร์โคด'}
										        data-inverted={''}
										        type="button"
										        onClick={() => {
											        this.scanToSaveSerialNumber()
										        }}
										>
											<i className="barcode icon"/>
										</button>
										<button className="ui icon button"
										        data-tooltip={'นำเข้าข้อมูล'}
										        data-inverted={''}
										        type="button"
										        onClick={() => {
											        window.Global.reactToDom(
												        window.$('body'),
												        <div>
													        <ProductSerialNumberImport

													        />
												        </div>
											        )
										        }}
										>
											<i className="arrow up icon"/>
										</button>
										{/*<button className="ui icon button"*/}
										{/*        data-tooltip={'ดาวโหลดรายงาน'}*/}
										{/*        data-inverted={''}*/}
										{/*        type="button"*/}
										{/*        onClick={() => {*/}
										{/*	        this.downloadReport()*/}
										{/*        }}*/}
										{/*>*/}
										{/*	<i className="download icon"/>*/}
										{/*</button>*/}
										<button className="ui icon button green"
										        type="submit"
										        style={{
											        width: '12rem'
										        }}
										>
											<i className="search icon"/>&nbsp;&nbsp;ค้นหา
										</button>
									</div>
								</div>
							</div>
						</form>
					</div>
					<div className="ui basic table can click Table_root td-top-xs" style={{marginTop: 10}}>
						<div className="thead">
							<div className="tr">
								<div className="th span2">สินค้า</div>
								<div className="th span4">Serial Number / วันหมดอายุ</div>
								<div className="th span2">อยู่ที่ไหน / หมายเหตุ</div>
								<div className="th span2">เอกสารอ้างอิง</div>
								<div className="th span4">ราคาซื้อ / ราคาขาย / กำไร</div>
								<div className="th span2">วันที่แก้ไข</div>
							</div>
						</div>
						<div className="tbody">
							{
								this.state.is_loading
									? <div className="tr">
										<div className="td center aligned" data-info="nodata">
											<div className="ui active centered inline small loader"/>
										</div>
									</div>
									: null
							}
							{
								!this.state.is_loading
								&& this.state.products_serial_number.length === 0
								&& (
									!window.Global.getAllQueryStrings().page
									|| window.Global.getAllQueryStrings().page === '1'
								) ?
									<div className="tr">
										<div className="td span16" style={{textAlign: 'center'}}>ไม่พบข้อมูล</div>
									</div>
									: null
							}
							{
								!this.state.is_loading
								&& this.state.products_serial_number.length > 0 ?
									this.state.products_serial_number.map((product_serial_number, product_serial_number_i) => {
										let redirect_url = "/v2/products/" + product_serial_number.product_id + "/serial-number/" + product_serial_number.id + '/edit';

										return (
											<div className="tr item-serial-number"
											     key={product_serial_number_i}
											     data-scan_barcode={
												     product_serial_number.serial_number === null
													     ? '1'
													     : ''
											     }
											     data-index={product_serial_number_i}
											     data-product_serial_number_id={product_serial_number.id}
												// onClick={(e) => {
												//    if (!window.$(e.target).is("button")
												//      && !window.$(e.target).is("i")
												//      && !window.$(e.target).is("[class='link']")
												//    ) {
												//      this.props.history.push({
												// 	     pathname: redirect_url,
												// 	     state: null,
												//      });
												//    }
												// }}
											>
												<div className="td span2">
													<Link to={"/v2/products/" + product_serial_number.product_id}
													      className={"link"}
													>
														<div className={'font-bold'}>{product_serial_number.product.name}</div>
														<div>{product_serial_number.product.code}</div>
													</Link>
												</div>
												<div className="td span4">
													<div className={'flex flex-row'}>
														<div>
															<div>
																<b className={'serial-number'}
																   style={{fontSize: '1.2rem'}}>
																	{
																		product_serial_number.serial_number
																			?
																			<span>
																				<span ref={(ref) => {
																					window.$(ref)
																						.attr('data-tooltip', 'คัดลอกข้อความ')
																						.attr('data-inverted', '1')
																						.on('click', function () {
																							let text = window.$(this).text()
																							let clipboard = window.$(this).attr('data-clipboard')
																							if (clipboard) {
																								text = clipboard
																							}
																							window.Global.copyTextToClipboard(text)
																						})
																				}}
																				      data-copy_text_to_clipboard={1}
																				      data-clipboard={product_serial_number.serial_number}>
																				<span className={'text-sm'}>
																					<i className={'ui icon clone outline'}></i>
																				</span>
																					&nbsp;&nbsp;
																				</span>{product_serial_number.serial_number}
																			</span>
																			:
																			<span className={'text-red-700'}>-</span>
																	}
																</b>
															</div>
															{
																product_serial_number.expire_date ?
																	<div>{window.Global.getDateThai(product_serial_number.expire_date, {is_show_time: false})}</div>
																	: null
															}
														</div>
														<div className={'ml-auto'} style={{whiteSpace: 'pre-line'}}>
															<div dangerouslySetInnerHTML={{
																__html: product_serial_number.html_status
															}}
															/>
														</div>
													</div>
													{
														product_serial_number.on_payments
														&& product_serial_number.on_payments.length > 0
														&&
														<div className={'ui message yellow tiny flex flex-col gap-2'}>
															{
																product_serial_number.on_payments.map((on_payment, i) => {
																	return (
																		<a key={i}
																		   href={on_payment.url}
																		   className={"link flex"}
																		>
																			· {window.Global.getDateThai(on_payment.doc_date, {is_show_time: false})} ({on_payment.method2})
																			<br/>{on_payment.title} {on_payment.desc}
																		</a>
																	)
																})
															}
														</div>
													}

												</div>
												<div className="td span2">
													<div>
														<div>
															{
																product_serial_number.store_in_stock
																	? "คลังสินค้า " + product_serial_number.store_in_stock.name
																	: "-"
															}
														</div>
														<div>
															{product_serial_number.remark || '-'}
														</div>
													</div>
												</div>
												<div className="td span2">
													{
														product_serial_number.purchase_order_code
															?
															<div>
																<a href={process.env.REACT_APP_DOMAIN + "/purchase_orders/" + product_serial_number.purchase_order_id}
																   className={"link"}
																   data-tooltip={"ใบสั่งซื้อ"}
																   data-inverted={""}
																   data-position={"top left"}
																>
																	{product_serial_number.purchase_order_code}
																</a>
															</div>
															:
															"-"
													}
												</div>
												<div className="td span4">
													<div className={'grid grid-cols-2 gap-2'}>
														<div className={'flex flex-col gap-2'}>
															{
																product_serial_number.cost
																&&
																product_serial_number.cost.map((cost, i) => {
																	return (
																		<div className={'p-2 bg-red-100 rounded'}
																		     key={i}
																		     data-tooltip={'ไปยังเอกสาร'}
																		     data-inverted={''}
																		>
																			<a href={cost.payment.url}
																			   className={'leading-3'}
																			>
																				{
																					cost.payment.doc_date
																					&&
																					<>
																						<span><b>ซื้อ</b> · {window.Global.getDateThai(cost.payment.doc_date)}</span>
																						<br/>
																					</>
																				}
																				<span className={"capitalize"}
																				      data-tooltip={"ซื้อจาก"}
																				      data-inverted={""}
																				      data-position={"top left"}
																				>
																					{cost.payment.relationship.name}
																				</span>
																				<br/>
																				<span
																					className={'font-bold text-lg flex text-right text-red-700'}>
																					{cost.summary.price_per_unit_include_vat.format(2)}
																				</span>
																			</a>
																		</div>
																	)
																})
															}
														</div>
														<div className={'flex flex-col gap-2'}>
															{
																product_serial_number.revenue
																&&
																product_serial_number.revenue.map((revenue, i) => {
																	return (
																		<div className={'p-2 bg-green-100 rounded'}
																		     key={i}
																		     data-tooltip={'ไปยังเอกสาร'}
																		     data-inverted={''}
																		>
																			<a href={revenue.payment.url}
																			   className={'leading-3'}
																			>
																				{
																					revenue.payment.doc_date
																					&&
																					<>
																						<span><b>ขาย</b> · {window.Global.getDateThai(revenue.payment.doc_date)}</span>
																						<br/>
																					</>
																				}
																				<span className={"capitalize"}
																				      data-tooltip={"ลูกค้า"}
																				      data-inverted={""}
																				      data-position={"top left"}
																				>
																					{revenue.payment.relationship.name}
																				</span>
																				<br/>
																				<span
																					className={'font-bold text-lg flex text-right text-green-700'}>
																					{revenue.summary.price_per_unit_include_vat.format(2)}
																				</span>
																			</a>
																		</div>
																	)
																})
															}
														</div>
													</div>
													{
														product_serial_number.predict_profit
															? (
																<div className={'font-bold text-center p-3 text-lg'}>
																	{
																		product_serial_number.predict_profit > 0
																			? <div className={'text-green-700'}>
																				กำไร <span
																				className={'text-xs'}>≈</span> {product_serial_number.predict_profit.format(2)}
																			</div>
																			: <div className={'text-red-700'}>
																				ขาดทุน
																				<span
																					className={'text-xs'}>≈</span> {(Math.abs(product_serial_number.predict_profit)).format(2)}
																			</div>
																	}
																</div>
															)
															: null
													}
												</div>
												<div className="td span2">
													<div>
														<div className={'text-sm mb-2'}>
															{
																product_serial_number.updated_user
																	?
																	<div data-tooltip={"ผู้แก้ไข"}
																	     data-inverted={""}
																	     data-position={"top left"}
																	>
																		{product_serial_number.updated_user.name}
																	</div>
																	: null
															}
															{
																product_serial_number.date_updated
																	?
																	<div data-tooltip={"วันที่แก้ไข"}
																	     data-inverted={""}
																	     data-position={"top left"}
																	>
																		{window.Global.getDateThai(product_serial_number.date_updated, {is_show_time: true})}
																	</div>
																	: null
															}
														</div>
														<div className={'flex flex-row gap-4'}>
															<div>
																<Link className="ui button icon"
																      style={{borderRadius: 4}}
																      to={redirect_url + '?redirect=' + encodeURIComponent(window.location.pathname + window.location.search)}
																>
																	<i className={'ui icon pencil'}/>
																</Link>
															</div>
															{
																product_serial_number.is_deleted
																&& product_serial_number.source === 'initial'
																	? null
																	: <Link className="ui button blue mt-2"
																	        style={{borderRadius: 4}}
																	        to={"/v2/shipments?has_product_ids=" + product_serial_number.product_id + '&search_product_serial_number=' + product_serial_number.id + '&status=all'}
																	>
																		ประวัติ
																	</Link>

															}
														</div>
													</div>
												</div>
											</div>
										)
									}) : null
							}
						</div>
					</div>
				</div>
			</div>
		)
	}

	render() {
		if (this.state.loading) {
			return <div className="ui active centered inline loader"/>
		}

		if (this.state.mode === 'list') {
			return this.renderList();
		}

		return (
			<>
				<div ref={(ref) => {
					if (!ref) return;
					this.$parent = window.$(ref);
					this.$parent.find('form').form2('setup');
					this.$parent.find('form').form2('submit', {
						method: this.state.mode === 'create' ? 'POST' : 'PUT',
						url: process.env.REACT_APP_DOMAIN + '/api/product_serial_number',
						beforeSent: (object) => {
							return object;
						},
						loadingButton: window.$(this.$parent).find('#submit-button'),
						onSuccess: () => {
							window.Global.messageTop({
								type: 'positive',
								message: this.state.mode === 'create' ? 'เพิ่มข้อมูลเรียบร้อย' : 'แก้ไขข้อมูลเรียบร้อย'
							});
							if (this.state.qs.redirect
								&& this.state.mode !== 'create'
							) {
								window.location = decodeURIComponent(this.state.qs.redirect);
							} else {
								this.props.history.push({
									pathname: '/v2/products/' + this.state.product.id + '/serial-number',
									state: null
								});
							}
						}
					});
				}}
				     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
				     className="main ui container"
				>
					{
						this.state.product
						&&
						this.renderHeader()
					}
					<div id="ProductBarcodeEdit_root">
						<form className="ui form" autoComplete="off">
							<div className="ui grid ui tall stacked segment" style={{marginTop: 0}}>
								<div className={"flex row wrap two column computer"}>
									<div className={"column"}>
										<h4 className="ui dividing header">รายละเอียด</h4>
										<div className="field">
											<label>Serial Number</label>
											<div className="ui left icon input">
												<input type="text"
												       name="serial_number"
												       placeholder="Serial Number"
												       defaultValue={this.state.product_serial_number.serial_number || ''}
												/>
												<i className="barcode icon"/>
											</div>
										</div>
										<div className="field">
											<label>วันที่หมดอายุ</label>
											<div data-form_calendar="date"
											     data-input_name="expire_date"
											     data-placeholder="วันที่หมดอายุ"
											     data-locale="th"
											     data-initialdate={this.state.product_serial_number.expire_date}
											/>
										</div>
										<div className="field">
											<label>หมายเหตุ</label>
											<textarea name="remark"
											          defaultValue={this.state.product_serial_number.remark}/>
										</div>
									</div>
								</div>
								<div className="column row">
									<div className="column">
										<div className="ui error message"/>
										<div className="flex row">
											{
												this.state.mode === 'edit' ?
													<>
														<input type="hidden" name="product_serial_number_id"
														       defaultValue={this.state.product_serial_number.id}/>
														{/*<button className="ui red button" type="button" onClick={() => {*/}
														{/*	this.void();*/}
														{/*}}>ลบ*/}
														{/*</button>*/}
													</>
													: null
											}
											{
												this.state.mode === 'create' ?
													<input type="hidden" name="product_id"
													       defaultValue={this.state.product.id}/>
													: null
											}
											<div className="right floated">
												<Link id="cancelButton"
												      to={
													      this.state.qs.redirect
														      ? decodeURIComponent(this.state.qs.redirect)
														      : "/v2/products/" + this.state.product.id + "/serial-number"
												      }
												      className="ui button">ยกเลิก</Link>
												<button className="ui right floated primary button"
												        type="submit">บันทึก
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</>
		);
	}

	void() {
		window.Global.confirm({
			title: 'ยืนยันยกเลิก serial number',
			content: '<form class="ui form">\n\t<p>โปรดยืนยันยกเลิก serial number การกระทำนี้ไม่สามารถกู้คืนข้อมูลได้</p>\n\t<div class="ui error message"></div>\n</form>',
			cancel_text: 'ไม่ดำเนินการ',
			approve_text: 'ลบข้อมูล',
			onShowToSetupForm: ($modal) => {
				$modal.find('form').form2('setup');
				$modal.find('form').form2('submit', {
					method: 'DELETE',
					url: process.env.REACT_APP_DOMAIN + '/api/product_serial_number',
					loadingButton: $modal.find('.button.approve'),
					beforeSent: (data) => {
						data.product_serial_number_id = this.state.product_serial_number.id;
						return data;
					},
					onSuccess: (response) => {
						$modal.modal('hide');
						window.Global.messageTop({
							type: 'positive',
							message: 'ลบข้อมูลสำเร็จ'
						});
						this.props.history.push({
							pathname: '/v2/products/' + this.state.product.id + '/serial-number',
							state: null
						});
					}
				});
			}
		});
	}
}

export class ProductSerialNumberImport extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			isPreload: false,
			product_serial_number: props.product_serial_number,
			response: {},
		};
	}

	// route() {
	// 	window.Route.on({
	// 		'/v2/relationship-duplicate': () => {
	// 			this.fetch();
	// 		}
	// 	}).match();
	// }

	componentDidMount() {

	}

	// componentDidUpdate(prevProps) {
	// 	if (this.props.location.pathname !== prevProps.location.pathname) {
	// 		this.route();
	// 	}
	// }

	render() {
		if (this.state.loading) {
			return null;
		}

		return (
			<Modal className="ui modal large"
			       closable={false}
			       onShowToSetupForm={($modal) => {

			       }}
			>
				<div className="header">
					<h2>ระบบนำเข้าข้อมูล</h2>
				</div>
				<div className="content">
					<form className="ui form ui tall stacked padded segment"
					      autoComplete={'off'}
						// key={'d' + window.Global.getRandomInt(1, 10000000)}
						   ref={(ref) => {
							   window.$(ref).form2('setup');
							   window.$(ref).form2('submit', {
								   method: 'POST',
								   url: process.env.REACT_APP_DOMAIN + '/api/v1/product_serial_number/import-by-google-sheet',
								   beforeSent: (object) => {
									   if (this.state.isPreload) {
										   object.is_confirm = true;

										   if (!window.confirm('ยืนยันหรือไม่?')) {
											   return false;
										   }
									   }

									   return object;
								   },
								   loadingButton: window.$(ref).find('.button.approve'),
								   submitButton: window.$(ref).find('.button.approve'),
								   onSuccess: (response) => {
									   if (!response.success) {
										   return;
									   }
									   if (response.is_confirm === 0) {
										   this.setState({
											   ...this.state,
											   isPreload: true,
											   response: response,
										   })
									   } else {
										   this.setState({
											   ...this.state,
											   isSuccess: true,
										   })

										   window.Global.messageTop({
											   type: 'positive',
											   message: 'บันทึกข้อมูลเรียบร้อย'
										   });
									   }
								   }
							   });
						   }}
					>
						<div className="flex row wrap two column computer padded">
							<div className="column field required">
								<label htmlFor="">Google Sheet ID</label>
								<input type="text"
								       name={'google_sheet_id'}
								       placeholder={'Google Sheet ID'}
								       readOnly={this.state.isPreload}
								/>
							</div>
							<div className="column field required">
								<label htmlFor="">Google Sheet Name</label>
								<input type="text"
								       name={'google_sheet_name'}
								       placeholder={'Google Sheet Name'}
								       defaultValue={'Sheet1'}
								       readOnly={this.state.isPreload}
								/>
							</div>
							{/*<div className="column field">*/}
							{/*	<label htmlFor="">วันที่เอกสารยกมา</label>*/}
							{/*	<div data-form_calendar="date"*/}
							{/*	     data-input_name="doc_date"*/}
							{/*	     data-placeholder="วันที่"*/}
							{/*	     data-initialdate={''}*/}
							{/*	     data-locale="th"*/}
							{/*	/>*/}
							{/*</div>*/}
						</div>
						<h4 className="ui dividing header">สรุปยอดรายการทั้งหมด</h4>
						<div className="Table_root ui basic table theme1">
							<div className="thead">
								<div className="tr">
									<div className="th span2">ลำดับ</div>
									<div className="th span6">สินค้า</div>
									<div className="th span2">รหัสใบสั่งซื้อ</div>
									<div className="th span2">จำนวน</div>
									<div className="th span2"></div>
								</div>
							</div>
							<div className="tbody">
								<div>
									{
										this.state.isPreload
											?
											(
												this.state.response.items
												&&
												Object.keys(this.state.response.items).map((key, i) => {
													let item = this.state.response.items[key]

													return (
														<div key={key}
														     className={'tr flex row wrap'}
														>
															<div className="th span2">{i + 1}</div>
															<div className="th span6">
																<a href={"/v2/products/" + item.product.id}
																   className={'link'}
																   rel={'noopener noreferrer'}
																   target={'_blank'}
																   data-no_navigo={""}>
																	{item.product.name} ({item.product.code})
																</a>
															</div>
															<div className="th span2">
																<a href={"/purchase_orders/" + item.purchase_order.id}
																   className={'link'}
																   rel={'noopener noreferrer'}
																   target={'_blank'}
																   data-no_navigo={""}>
																	{item.purchase_order.code}
																</a>
															</div>
															<div className="th span2">
																<b className={'font-bold text-lg'}>
																	{item.count.format()}
																</b>
															</div>
															<div className="th span2"></div>
														</div>
													)
												})
											)
											: null
									}
									{
										!this.state.isPreload
										&&
										<div className={'tr flex row wrap'}>
											<div className="th span16" style={{textAlign: 'center'}}>โปรดกดปุ่มดึงข้อมูล</div>
										</div>
									}
									{
										this.state.isPreload
										&& this.state.response.items
										&& Object.keys(this.state.response.items).length === 0
										&&
										<div className={'tr flex row wrap'}>
											<div className="th span16" style={{textAlign: 'center'}}>ไม่มีรายการที่จะนำเข้า
											</div>
										</div>
									}
								</div>
							</div>
						</div>
						<div style={{margin: '2rem 0 0 0'}}>
							<div className="ui error message"/>
							{
								this.state.isPreload
								&&
								<div className={'mb-2'}>
									<div className={'ui message blue'}>โปรดอย่าแก้ไข Google Excel
										ก่อนดำเนินการนำเข้าข้อมูลเสร็จ
									</div>
								</div>
							}
							{
								!this.state.isSuccess
								&&
								<div className={'flex row wrap'}>
									<div>
										{/*<button type="button"*/}
										{/*        className="ui button"*/}
										{/*        onClick={() => {*/}

										{/*        }}*/}
										{/*>*/}
										{/*	ยกเลิก*/}
										{/*</button>*/}
									</div>
									<div className={'right floated'}>
										{
											this.state.isPreload
											&&
											<button type="button"
											        onClick={() => {
												        this.setState({
													        ...this.state,
													        isPreload: false,
													        response: {},
												        })
											        }}
											        className="ui button">
												เริ่มต้นใหม่
											</button>
										}
										<button type="button"
										        className="ui button green approve">
											{
												!this.state.isPreload
												&&
												<span>ดึงข้อมูล</span>
											}
											{
												this.state.isPreload
												&&
												<span>ยืนยันนำเข้าข้อมูล</span>
											}
										</button>
									</div>
								</div>
							}
							{
								this.state.isSuccess
								&&
								<div className={'flex row wrap'}>
									<div className={'right floated'}>
										<div style={{color: 'green'}}>บันทึกข้อมูลเรียบร้อย</div>
									</div>
								</div>
							}
						</div>
					</form>
				</div>
				<div className="actions">

				</div>
			</Modal>
		)
	}
}

function ProductSerialNumberFilterHistory({history, qs, on_payment}) {
	return (
		<Modal className="ui modal tiny"
		       closable={false}
		       onShowToSetupForm={($modal) => {
			       $modal.find('form').form2('setup', {})
			       $modal.find('form').form2('init', {
				       data: qs,
			       })

			       let $on_payment = $modal.find('input[name="on_payment_id"]').explorer({
				       url: process.env.REACT_APP_DOMAIN + '/api/payment',
				       additionalData: {
					       limit: 30,
					       page: 1,
				       },
				       key: 'payment',
				       template: {
					       list: (value) => {
						       // let search = $product.val();
						       return window.Handlebars.compile('<a class="item flex row"><b>{{date doc_date}}</b> - {{title}} {{desc}}</a>')(value)
					       },
					       selected: {
						       display_template: '<b>{{date doc_date}}</b><br>{{title}}<br>{{desc}}',
						       value: 'id',
						       placeholder: ''
					       }
				       },
				       onSelected: () => {
					       // setTimeout(() => {
					       //    $modal.find('form').trigger('submit')
					       // }, 50)
				       }
			       })
			       if (on_payment) {
				       $on_payment.explorer('set value', on_payment)
			       }

			       // setTimeout(() => {
			       //    $modal.find('input[name="search"]').focus()
			       // }, 500)

			       $modal.find('form').form2('submit', {
				       method: 'POST',
				       url: process.env.REACT_APP_DOMAIN + '',
				       beforeSent: (object) => {
					       // if (!object.payment_id) {
					       //    return false
					       // }

					       // let data = window.$('#Search_root form').serializeObject()

					       history.push(
						       window.Global.getQueryStringLinkFromObject({
							       // status: 'all',
							       ...object,
							       // payment_id: object.payment_id,
						       })
					       )

					       $modal.modal('hide')

					       return false;
				       },
				       loadingButton: $modal.find('.button.approve'),
				       onSuccess: () => {

				       }
			       })
		       }}>
			<div className="header">
				<h2>ค้นหาประวัติจากเอกสาร</h2>
			</div>
			<div className="content">
				<form className="ui form">
					<div className="flex row wrap column one column computer padded">
						<div className="column field">
							<label>ค้นหาเอกสารทางการเงิน</label>
							<input type="text"
							       name="on_payment_id"
							/>
						</div>
						<div className="column field">
							<label>ช่วงวันที่ - ที่ซีเรียลอยู่ในเอกสารทางการเงิน</label>
							<div data-form_calendar="date"
							     data-input_name="on_payment_start_doc_date"
							     data-placeholder="ช่วงวันที่"
							     data-end_calendar="on_payment_end_doc_date"
							     data-locale="th"
							     data-initialdate=""
							/>
						</div>
						<div className="column field">
							<label>ถึงวันที่ - ที่ซีเรียลอยู่ในเอกสารทางการเงิน</label>
							<div data-form_calendar="date"
							     data-input_name="on_payment_end_doc_date"
							     data-placeholder="ถึงวันที่"
							     data-start_calendar="on_payment_start_doc_date"
							     data-locale="th"
							     data-initialdate=""
							/>
						</div>
					</div>
					<div className="ui error message"/>
				</form>
			</div>
			<div className="actions">
				<div className="flex row">
					<div className="right floated">
						<div className="ui deny button">ยกเลิก</div>
						<div className="ui approve green right button">ตกลง</div>
					</div>
				</div>
			</div>
		</Modal>
	)
}
